import React, { FunctionComponent } from 'react';
import { Box, makeStyles, Slide, Theme } from '@material-ui/core';
import moment from 'moment';
import LicenseDetailNode from '../LicenseDetailNode/LicenseDetailNode';
import { Application } from '../../../store/modules/application/types';
import { getPersonSimpleName } from '../../../utils/utils';

type LicenseDetailNodeProps = {
    doShowDetail: boolean;
    application: Application;
    className: string;
};

const LicenseDetail: FunctionComponent<LicenseDetailNodeProps> = (props) => {
    const classes = makeStyles((theme: Theme) => ({
        header: {
            color: theme.palette.primary.light,
            fontWeight: 500,
        },
    }))();
    const { doShowDetail, application, className } = props;
    return (
        <aside>
            {!doShowDetail && <Box className={className}></Box>}
            <Slide in={doShowDetail} direction="right" mountOnEnter={true} unmountOnExit={true}>
                <Box className="detail-container detail-container-mobile">
                    <h3 className={classes.header}>DETAILS</h3>
                    <LicenseDetailNode
                        label="Type"
                        value={
                            (typeof application['type'] === 'string' && application['type']) ||
                            (typeof application['type'] === 'object' && application['type']['name'])
                        }
                        isEditable={false}
                    />
                    <LicenseDetailNode
                        label="Licensee"
                        value={getPersonSimpleName(application?.person?.name)}
                        isEditable={false}
                    />
                    <LicenseDetailNode
                        label="Status"
                        value={application.status && application.status}
                        isEditable={false}
                    />
                    <LicenseDetailNode
                        label="Issue Date"
                        value={application.issueDate && moment(application.issueDate).format('L')}
                        isEditable={false}
                    />
                    <LicenseDetailNode
                        label="Expiration Date"
                        value={application.expirationDate && moment(application.expirationDate).format('L')}
                        isEditable={false}
                    />
                </Box>
            </Slide>
        </aside>
    );
};

export default LicenseDetail;
